import { login } from 'actions'
import LoginForm from 'components/LoginForm'
import routes from 'config/routes'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { parseError } from 'utils'

function Login(props) {
  const { addToast } = useToasts()

  const submit = async values => {
    try {
      const { username, password } = values
      await props.login(username, password)
      props.history.push(routes.dashboard)
    } catch (err) {
      const { non_field_errors } = parseError(err)
      addToast(non_field_errors || 'Error logging in', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  if (props.authenticated) {
    return <Redirect to={routes.dashboard} />
  }

  return (
    <div id="login">
      <Row>
        <Col md={8} lg={6} className="mx-auto mt-3">
          <LoginForm onSubmit={submit} />
        </Col>
      </Row>
    </div>
  )
}

Login.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
}

const mapState = state => ({
  authenticated: state.auth.authenticated,
})

const mapDispatch = {
  login,
}

export default connect(mapState, mapDispatch)(Login)
